module.exports = __webpack_public_path__ + "static/media/FlappyBiene.6cfc834c.png";